import React from "react";
import { useAccommodationRequestGetQuery } from "@graphql";
import { Spinner } from "@components";
import { AccommodationRequestPage } from "./AccommodationRequestPage";
import { AccommodationRequest } from "./AccommodationRequest";

type Props = {
  requestId: string;
  onClose: () => void;
};

export function AccommodationRequestViewPage(props: Props) {
  const { data, loading, error } = useAccommodationRequestGetQuery({
    variables: { requestId: props.requestId },
    fetchPolicy: "network-only"
  });

  if (loading || !data) {
    return <Spinner fullHeight />;
  }

  if (error) {
    throw new Error(error.toString());
  }

  return (
    <AccommodationRequestPage
      formProps={{
        bookingGroupId: data.accommodationRequestById.bookingGroup,
        initialValues: AccommodationRequest.FromFull(data.accommodationRequestById),
        isNew: false,
        isDisabled: true
      }}
    />
  );
}
